export default angular.module('ApiUtils.dms', [
    'ApiUtils.dms.genericProducts',
    'ApiUtils.dms.cropData',
    'ApiUtils.dms.soilType'
]);

